/// <amd-module name="Feed/Common/Types/IPackageFollowState" />
export interface IPackageFollowState {
    isPackageFollowed: boolean;
    isFollowStateLoaded: boolean;
    subscriptionId: string;
}
